import { toCurrencyString } from '../helpers/numberHelpers'

export const formattedPhone = (number) => {
  if (number == null || number.length !== 10) return number

  const digits = number.split('')
  return `(${digits.slice(0, 3).join('')}) ${digits.slice(3, 6).join('')}-${digits.slice(6, 10).join('')}`
}

// Function to give a default string if value is missing or blank
export const displayField = (str) => {
  return [null, undefined, ''].includes(str) ? '--' : str
}

// Function to give a default string if number value is missing or blank
export const displayCurrency = (val) => {
  return [null, undefined, ''].includes(val) ? '--' : toCurrencyString(val)
}
